import { useEffect, useState } from "react";
import {
  useAlertStore,
  useGeneralStore,
  usePopupStore,
  useThemeStore,
} from "../../../../stores";
import { BackContainer, Vec2 } from "../../../../types";
import { Column, Row } from "../../../containers";
import { CashActivityData, CashActivitySpend } from "../types";
import { PopupBack, PopupClose } from "../../../../popup";
import { TextInput } from "../../../inputs";
import { Heading } from "../../../typography";
import { addComma } from "../../../../utils";
import OptionList from "../../../optionlist";
import { LogoutIcon } from "../../../../assets/icons";
import { CashApi } from "../../../../api";
import { CashDetails } from "../../../cash";

const CashSpendActivityPopup = <T extends {}>(
  props: BackContainer<CashActivityData, T>
) => {
  const { data, back } = props;
  const { description, total_price, customer, id } = data as CashActivitySpend;

  const theme = useThemeStore((s) => s.theme);
  const getCustomerById = useGeneralStore((s) => s.getCustomerById);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);
  const pushAlert = useAlertStore((s) => s.pushAlert);
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxWidth: 816,
        maxHeight: "80%",
        overflowY: "auto",
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  const [mousePos, setMousePos] = useState<Vec2>({ x: 0, y: 0 });

  const onRightClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void => {
    e.preventDefault();
    setMousePos({ x: e.clientX, y: e.clientY });
  };

  const gotoCash = (): void => {
    CashApi.findCashById(id.$oid)
      .then((cash) => {
        setPopupBody(
          <CashDetails<BackContainer<CashActivityData, T>>
            cash={cash}
            back={{ component: CashSpendActivityPopup, props }}
          />
        );
      })
      .catch((err) => {
        pushAlert(err.msg || "unknown error", "error");
      });
  };

  return (
    <Column
      style={{ marginBottom: "1rem", position: "relative" }}
      gap={20}
      props={{ onContextMenu: onRightClick }}
    >
      <PopupClose />

      {back ? (
        <PopupBack Component={back.component} props={back.props} />
      ) : (
        <></>
      )}

      <OptionList
        mousePos={mousePos}
        options={[
          {
            title: "برو به نقدی",
            Icon: LogoutIcon,
            onClick: gotoCash,
          },
        ]}
      />

      <Heading
        textStyles={{ marginTop: "1rem" }}
        size={19}
        color={theme.textOnOverlay}
      >
        خرج نقدی
      </Heading>

      <Row style={{ width: "90%" }} gap={20} className="factor-activity-row">
        {customer ? (
          <TextInput
            label="مشتری"
            value={getCustomerById(customer.$oid)?.fullname || ""}
            inputProps={{ readOnly: true }}
          />
        ) : (
          <></>
        )}

        <TextInput
          label="بابت"
          value={description}
          inputProps={{ readOnly: true }}
        />

        <TextInput
          label="مبلغ"
          value={addComma(total_price)}
          inputProps={{ readOnly: true }}
        />
      </Row>
    </Column>
  );
};

export default CashSpendActivityPopup;
